import { render, staticRenderFns } from "./BindUSDTAcc.vue?vue&type=template&id=581b78e2&scoped=true"
import script from "./BindUSDTAcc.vue?vue&type=script&lang=js"
export * from "./BindUSDTAcc.vue?vue&type=script&lang=js"
import style0 from "./BindUSDTAcc.vue?vue&type=style&index=0&id=581b78e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b78e2",
  null
  
)

export default component.exports